export enum ServiceAction {
  fetch = 'fetch',
  post = 'post',
  put = 'put',
  delete = 'delete',
  run = 'run',
}
